import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  // Detect scroll position to add shadow effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll to a section on the page
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setMenuOpen(false); // Close the menu for mobile view
    }
  };

  // Scroll to a section, navigating if needed
  const navigateAndScroll = (sectionId) => {
    if (location.pathname === '/') {
      // Already on the home page, just scroll
      scrollToSection(sectionId);
    } else {
      // Navigate to home and pass sectionId in state
      navigate('/', { state: { scrollTo: sectionId } });
    }
  };

  // Scroll to top when navigating to "Home"
  const navigateHome = () => {
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
    }
  };

  // On component mount, handle scrolling based on location.state
  useEffect(() => {
    if (location.state?.scrollTo) {
      const sectionId = location.state.scrollTo;
      scrollToSection(sectionId);

      // Clear state after scrolling
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  return (
    <nav
      className={`fixed top-0 w-full z-50 transition-all ${
        isScrolled ? 'bg-[#0A0F1F] shadow-lg' : 'bg-transparent'
      } backdrop-blur-lg bg-opacity-80`}
    >
      <div className="container mx-auto flex justify-between items-center px-6 py-4">
        {/* Logo */}
        <button onClick={navigateHome} className="flex items-center">
          <img
            src="/logo/black_bg_logo_only-transparent.png"
            alt="Logo"
            className="h-20 w-auto"
          />
          <p className="text-4xl font-bold bg-gradient-to-r from-white to-[#0097B2] bg-clip-text text-transparent">
            NIB ERP
          </p>
        </button>

        {/* Desktop Menu */}
        <ul className="hidden md:flex space-x-8 text-white">
          <li>
            <button
              onClick={() => navigateAndScroll('features')}
              className="hover:text-yellow-400 transition"
            >
              Features
            </button>
          </li>
          <li>
            <button
              onClick={() => navigateAndScroll('cta')}
              className="hover:text-yellow-400 transition"
            >
              Demo
            </button>
          </li>
          <li>
            <button
              onClick={() => navigateAndScroll('about')}
              className="hover:text-yellow-400 transition"
            >
              About
            </button>
          </li>
        </ul>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-white focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? '✖' : '☰'}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0A0F1F]">
          <ul className="flex flex-col items-center space-y-4 py-4 text-white">
            <li>
              <button
                onClick={() => navigateAndScroll('features')}
                className="hover:text-yellow-400 transition"
              >
                Features
              </button>
            </li>
            <li>
              <button
                onClick={() => navigateAndScroll('cta')}
                className="hover:text-yellow-400 transition"
              >
                Demo
              </button>
            </li>
            <li>
              <button
                onClick={() => navigateAndScroll('about')}
                className="hover:text-yellow-400 transition"
              >
                About
              </button>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
